import React from "react";
import { Link } from "react-router-dom";
import { Mail, Twitter, Music2, Film, Tv, Info, Download } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10 mt-16">
      <div className="padding py-12">
        {/* Main Footer Content */}
        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-8 md:gap-12 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to={"/"} className="inline-block mb-4">
              <h2 className="text-red font-bold poppins text-2xl lg:text-3xl hover:scale-105 transition-transform duration-300">
                FilmJetHub
              </h2>
            </Link>
            <p className="text-white/60 mont text-sm leading-relaxed mb-4">
              Your ultimate destination for streaming unlimited movies and TV shows. Discover, watch, and enjoy premium entertainment.
            </p>
            {/* Social Media Links */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://twitter.com/FilmJetHub"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative w-10 h-10 flex items-center justify-center rounded-full bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-red hover:border-red transition-all duration-300"
                aria-label="Follow us on Twitter"
              >
                <Twitter className="text-white/70 group-hover:text-white transition-colors duration-300" size={18} />
              </a>
              <a
                href="https://www.tiktok.com/@filmjethub"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative w-10 h-10 flex items-center justify-center rounded-full bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-red hover:border-red transition-all duration-300"
                aria-label="Follow us on TikTok"
              >
                <Music2 className="text-white/70 group-hover:text-white transition-colors duration-300" size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white mont font-semibold text-base mb-4 uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to={"/"}
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Film className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  Movies
                </Link>
              </li>
              <li>
                <Link
                  to={"/tvshows"}
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Tv className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  TV Shows
                </Link>
              </li>
              <li>
                <Link
                  to={"/download"}
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Download className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  Download App
                </Link>
              </li>
              <li>
                <Link
                  to={"/about"}
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Info className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Support & Contact */}
          <div>
            <h3 className="text-white mont font-semibold text-base mb-4 uppercase tracking-wider">
              Support
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:filmjethub@gmail.com"
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Mail className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="mailto:filmjethub@gmail.com?subject=Advertising Inquiry"
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Mail className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  Advertising
                </a>
              </li>
              <li>
                <a
                  href="mailto:filmjethub@gmail.com?subject=Report a Problem"
                  className="text-white/70 mont text-sm hover:text-red transition-colors duration-300 flex items-center gap-2 group"
                >
                  <Mail className="text-white/40 group-hover:text-red transition-colors duration-300" size={16} />
                  Report Issue
                </a>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-white/10">
              <p className="text-white/60 mont text-xs">
                Email us at{" "}
                <a
                  href="mailto:filmjethub@gmail.com"
                  className="text-red hover:text-red/80 transition-colors duration-300"
                >
                  filmjethub@gmail.com
                </a>
              </p>
            </div>
          </div>

          {/* Newsletter/Info */}
          <div>
            <h3 className="text-white mont font-semibold text-base mb-4 uppercase tracking-wider">
              Stay Connected
            </h3>
            <p className="text-white/60 mont text-sm leading-relaxed mb-4">
              Follow us on social media to stay updated with the latest movies, TV shows, and exclusive content.
            </p>
            <div className="flex flex-col gap-2">
              <a
                href="https://twitter.com/FilmJetHub"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 mont text-sm hover:text-red transition-colors duration-300"
              >
                @FilmJetHub
              </a>
              <a
                href="https://www.tiktok.com/@filmjethub"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 mont text-sm hover:text-red transition-colors duration-300"
              >
                @filmjethub
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 mont text-xs text-center md:text-left">
              © {currentYear} FilmJetHub. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-xs text-white/50 mont">
              <Link to={"/"} className="hover:text-red transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to={"/"} className="hover:text-red transition-colors duration-300">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
